/**
 * Central tag configuration.
 * NOTE: index.html inlines these same IDs (it cannot import TS) — keep both in sync.
 */

// TODO: paste the GTM container id, e.g. "GTM-XXXXXXX". Empty = gtag.js fallback.
export const GTM_CONTAINER_ID = "";

export const GA_MEASUREMENT_ID = "G-54FKZ41EY1";

// TODO: paste the LinkedIn Insight partner id. Empty = tag stays dormant.
export const LINKEDIN_PARTNER_ID = "";

// Production Google Calendar booking URL. Empty falls back to /#contact.
export const BOOKING_URL = "https://calendar.app.google/oMseav5GsJQqpoFcA";
